<template>
    <section>
        <v-data-table
            :headers="encabezado"
            :items="datos"
            class="elevation-1"
        >
            <template v-slot:[`item.opciones`]="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editar(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                small
                @click="eliminar(item)"
              >
                mdi-delete
              </v-icon>
            </template>
        </v-data-table>
    </section>
</template>
<script>
    export default{
        name: "TablaDatos",
        props: ["encabezado", "datos"],

        methods: {
            editar(item){
                this.$emit("editar", item)
            },

            eliminar(item){
                this.$emit("eliminar", item)
            }
        }
    }
</script>